import type { RouteLocationRaw } from 'vue-router'

export function getDefaultAuthenticatedRoute(roleType?: string): RouteLocationRaw {
    if (roleType === 'organizer') return { name: 'formats' }
    if (roleType === 'participant') return { name: 'explore' }
    return { name: 'profile' }
}
